import React from 'react';
import 'twin.macro';
import Button from 'components/Buttons/Button';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Background } from 'components/Background';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
  onPrev?: number;
}

export function PricingPageWrapper(props: Props) {
  const { children, onPrev } = props;
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);
  return (
    <div>
      <div tw="fixed inset-0">
        <Background />
      </div>

      <div tw="relative min-h-screen flex flex-col items-center justify-center">
        <div tw="absolute top-6 left-6">
          <Button
            icon={ChevronLeftIcon}
            onClick={() => navigate(onPrev || -1)}
            intent="none"
            tw="text-white hover:text-white/80"
          >
            {t('userSettings:subscription.pricing.backToTeetsh')}
          </Button>
        </div>
        <div tw="my-16 md:mt-12">{children}</div>
      </div>
    </div>
  );
}
